import type { ReactNode } from "react";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

/**
 * Shared chrome for the analytics demo views. Replaces the prototype's
 * sidebar shell — navigation now lives in the app header.
 */
export function AnalyticsPage({
  title,
  description,
  children,
}: {
  title: string;
  description?: string;
  children: ReactNode;
}) {
  useDocumentMeta({ title, description });
  return (
    <div className="analytics-scope">
      <div className="content">{children}</div>
    </div>
  );
}